import "./LoadingSpinner.css";

function LoadingSpinner({
  text = "Loading...",
  fullScreen = false,
}) {
  return (
    <div
      className={
        fullScreen
          ? "loading-spinner fullscreen"
          : "loading-spinner"
      }
    >
      <div className="spinner"></div>

      <p>{text}</p>
    </div>
  );
}

export default LoadingSpinner;